export default {
    confirmMessageLaceTop:
        'Option "Front" is already filled, selecting "Lace top" will clear and disable the option "Top Type". Are you sure?',
    confirmMessageRibben:
        'Option "Front" is already filled, selecting "Ribben" will clear and disable the option "Top Type". Are you sure?',
    confirmMessageKosherTop:
        'Option "Front" is already filled, selecting "Kosher Top" will clear and disable the option "Top Type". Are you sure?'
}
